module.exports = __webpack_public_path__ + "static/media/fernando-de-noronha-pe.e5bb145f.jpg";